import {FC} from 'react'

import {IconSize} from '@/theme/icons'
import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const TrademarkSymbolIcon: FC<IconProps> = ({
  color = theme.palette.text.primary,
  size = IconSize.medium,
}) => (
  <>
    <Icon size={size}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 5.75H8C7.58579 5.75 7.25 6.08579 7.25 6.5V13.5C7.25 13.9142 7.58579 14.25 8 14.25C8.41421 14.25 8.75 13.9142 8.75 13.5V11.25H10.3486L12.126 13.916C12.3557 14.2607 12.8214 14.3538 13.166 14.124C13.5107 13.8943 13.6038 13.4286 13.374 13.084L12.0209 11.0543C13.0342 10.6489 13.75 9.65804 13.75 8.5C13.75 6.98122 12.5188 5.75 11 5.75ZM11 9.75H8.75V7.25H11C11.6904 7.25 12.25 7.80964 12.25 8.5C12.25 9.19036 11.6904 9.75 11 9.75Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 10C1 5.02942 5.02942 1 10 1C14.9706 1 19 5.02942 19 10C19 14.9706 14.9706 19 10 19C5.02942 19 1 14.9706 1 10ZM10 2.5C5.85785 2.5 2.5 5.85785 2.5 10C2.5 14.1422 5.85785 17.5 10 17.5C14.1422 17.5 17.5 14.1422 17.5 10C17.5 5.85785 14.1422 2.5 10 2.5Z"
          fill={color}
        />
      </svg>
    </Icon>
  </>
)
